export const buildDragTrackData = (
	track: Track,
	source: string
): DragTrackData => ({
	id: track.id,
	title: track.title,
	albumNumber: track.album.number,
	trackSource: source,
	catalogue: track.album.catalogue?.name ?? '',
	genre: track.album.genre ?? '',
})
